export const UploadFileStatuses = {
  ready: 'READY',
  // includes uploading and processing
  loading: 'LOADING',
  error: 'ERROR',
  doneWithErrors: 'DONE_WITH_ERRORS',
  done: 'DONE',
}
